import { render, staticRenderFns } from "./OptionButton.vue?vue&type=template&id=d1e705d4&scoped=true"
import script from "./OptionButton.vue?vue&type=script&lang=js"
export * from "./OptionButton.vue?vue&type=script&lang=js"
import style0 from "./OptionButton.vue?vue&type=style&index=0&id=d1e705d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e705d4",
  null
  
)

export default component.exports